import { arrowBinary } from '../../../assets';
import Ava from '../../../components/Common/Ava/Ava';

import { ITeamBinarItem } from '../areas.types';

import { FC } from 'react';

export const TeamBinarItem: FC<ITeamBinarItem> = ({ teamQuantity, partner, setLoadBinary, setPositionBinary, setList, arrow }) => {
    return (
        <div className="team-binar-item">
            {arrow && (
                <img
                    className="arrow-binary"
                    src={arrowBinary}
                    alt=""
                />
            )}
            <div
                className="team-binar-item__avatar"
                onClick={() => {
                    if (!partner) return;
                    setLoadBinary(true);
                    setPositionBinary(partner?.positionId);
                    setList && setList(partner?.positionId);
                }}>
                {partner && (
                    <Ava
                        collectionId={partner.profile?.ava?.collectionId}
                        width="60px"
                        entityId={partner.profile?.ava?.entityId}
                    />
                )}
            </div>

            {partner && partner.teamQuantity > 1 && (
                <>
                    <div className="team-binar-item__cirlce-1"></div>
                    <div className="team-binar-item__cirlce-2"></div>
                </>
            )}
            <div className="team-binar-item__partners">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none">
                    <path
                        d="M10.5001 9.23818C11.3494 9.66481 12.0776 10.3495 12.609 11.2056C12.7143 11.3752 12.7669 11.4599 12.7851 11.5773C12.8221 11.8159 12.659 12.1091 12.4368 12.2035C12.3274 12.25 12.2045 12.25 11.9585 12.25M9.33348 6.72714C10.1978 6.2976 10.7918 5.40567 10.7918 4.375C10.7918 3.34433 10.1978 2.4524 9.33348 2.02286M8.16682 4.375C8.16682 5.82475 6.99156 7 5.54182 7C4.09207 7 2.91682 5.82475 2.91682 4.375C2.91682 2.92525 4.09207 1.75 5.54182 1.75C6.99156 1.75 8.16682 2.92525 8.16682 4.375ZM1.49303 11.0474C2.42305 9.65099 3.89062 8.75 5.54181 8.75C7.19301 8.75 8.66059 9.65099 9.5906 11.0474C9.79434 11.3533 9.89621 11.5062 9.88448 11.7016C9.87535 11.8538 9.77562 12.04 9.65406 12.1319C9.49794 12.25 9.28322 12.25 8.85377 12.25H2.22986C1.80042 12.25 1.58569 12.25 1.42957 12.1319C1.30801 12.04 1.20828 11.8538 1.19915 11.7016C1.18742 11.5062 1.28929 11.3533 1.49303 11.0474Z"
                        stroke="#3DA2FF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <p>{teamQuantity ? teamQuantity.toLocaleString() : 0}</p>
            </div>
        </div>
    );
};
